import Image1 from './img/testimonials/1.jpg'
import Image2 from './img/testimonials/2.jpg'
import Image3 from './img/testimonials/3.jpg'
import Image4 from './img/testimonials/4.jpg'
import Image5 from './img/testimonials/5.jpg'
import Image6 from './img/testimonials/6.jpg'
import Image7 from './img/testimonials/7.jpg'
import Image8 from './img/testimonials/8.jpg'


const Testimonial = [
    {
        id: 1,
        src: Image1,
        name: 'Sarah Wells',
        review: 'Dresses fit like a glove :), natus pariatur beatae facere accusantium corrupti ex asperiores perspiciatis praesentium! Officiis'
    },
    {
        id: 2,
        src: Image2,
        name: 'Emma Hill',
        review: 'They never disapoint, They always deliver am, natus pariatur beatae facere accusantium corrupti ex asperiores perspiciatis praesentium!'
    },
    {
        id: 3,
        src: Image3,
        name: 'Harrison Jack',
        review: 'Very comfortable wears, I recommend it. Nemo atque exercitationem nsantium corrupti ex asperiores perspiciatis praesentium!'
    },
    {
        id: 4,
        src: Image4,
        name: 'Carles Dale',
        review: 'Everything on the website is true, simply amazing  amet consectetur adipisicing elit. Nemo atque exercitationem non sint.'
    },
    {
        id: 5,
        src: Image5,
        name: 'Miguel Steffen',
        review: 'Incredible Collection, Both casuals and corporate! re accusantium corrupti ex asperiores perspiciatis praesentium!'
    },
    {
        id: 6,
        src: Image6,
        name: 'Richard Colen',
        review: 'Lovely customer service, riatur beatae facere accusantium corrupti ex asperiores perspiciatis praesentium!'
    },
    {
        id: 7,
        src: Image7,
        name: 'John Doe',
        review: 'They put in the effort for your satisfaction, I can only say praises.  on sint perferendis impedit optio ipsam, natus pariatur beatae facere'
    },
    {
        id: 8,
        src: Image8,
        name: 'Idara Godswill',
        review: 'Quite comfortable dresses, Please try to deliver on time. Nemo atque ex asperiores perspiciatis praesentium!'
    },
]

export default Testimonial;